<!-- TODO: Remove all fnd classes - this should only use emds classes-->
<div class="emds find-control-modal">
  <div class="modal-default modal-flex" id="{{baseId}}-ap-findcontrol-modal">
    <div class="modal-header">
      <div *ngIf="!loadingConfig" class="fnd-modal-header-title">
        <span>{{findControlDisplayName || findControlInitDto.FindControlBehavior.Name}}</span>
      </div>
    </div>
    <div class="modal-body">
      <ap-findcontrol-advanced class="search-results"
        [tableBaseId]="Id"
        [findControlId]="findControlId"
        [requiredSearchParameters]="requiredSearchParameters"
        [additionalSearchParameters]="additionalSearchParameters"
        [mode]="mode"
        [updateObs]="updateObs"
        [undoComponentId]="undoComponentId"
        [hiddenActionItems]="hiddenActionItems"
        (deleteClick)="onDelete($event)"
        (finishLoad)="onFindControlLoaded($event)"
        (finishLoadData)="onFindControlDataLoaded($event)"
        (hyperlinkClick)="onHyperLinkSelect($event)"
        (modifyClick)="onModify($event)"
        (newClick)="onNewClick()"
        (selectChange)="onSelectChange($event)"
      ></ap-findcontrol-advanced>
      <div *ngIf="!loadingData && !loadingConfig" class="selected-results">
        <div class="form-group">
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let chip of chips" (removed)="onChipDelete(chip)">
              {{chip.Item[findControlInitDto.FindControlBehavior.ColumnsConfig.PrimaryDisplayName]}}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <div class="selected-results-sm mat-exp hp-modal-expansion mat-exp-content-flush" *ngIf="!loadingData && !loadingConfig">
        <hr class="emds-hr" [hidden]="!chipsExpanded">
        <mat-expansion-panel [expanded]="chipsExpanded">
          <mat-chip-list class="chip-list-flush">
            <ng-container>
              <mat-chip *ngFor="let chip of chips" (removed)="onChipDelete(chip)">
                {{chip.Item[findControlInitDto.FindControlBehavior.ColumnsConfig.PrimaryDisplayName]}}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </ng-container>
          </mat-chip-list>
        </mat-expansion-panel>
      </div>
    </div>
    <div class="modal-footer">
      <div class="left">
        <a class="emds-a multi-select-a" (click)="toggleChips()" *ngIf="chips.length > 0">
          <span [hidden]="chipsExpanded" translate>Show Selected</span>
          <span [hidden]="!chipsExpanded" translate>Hide Selected</span>
        </a>
      </div>
      <div class="right">
        <ng-container [ngSwitch]="mode">
          <ng-container *ngSwitchCase="FindControlMode.Administration">
            <button id="fnd-configuration-close" class="btn btn-secondary" (click)="cancel()"
              translate>
              Close
            </button>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <button [disabled]="!dirty" id="fnd-configuration-save" class="btn btn-primary" (click)="close()"
              translate>
              Save
            </button>
            <button id="fnd-configuration-cancel" class="btn btn-secondary" (click)="cancel()"
              translate>
              Cancel
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
